import React from "react";

import {
   BIKE_LICENSE_TYPE_OPTIONS,
   BIKE_NO_CLAIM_BONUS_YEAR_OPTIONS,
   BIKE_RIDER_OPTIONS,
   BIKE_USAGE_OPTIONS,
   OTHER_OWNED_VEHICLE_NUMBER_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";

import {ValidateStep2Data} from "@validators/motor-cycle-insurance-form/step2-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";
import {
   CommonPolicyHolderClaimsForm
} from "@components/common/sub-components/insurance-form-parts/policy-holder-claims-form/common-policy-holder-claims-form";
import {
   CommonPolicyHolderConvictionsForm
} from "@components/common/sub-components/insurance-form-parts/policy-holder-convictions-form/common-policy-holder-convictions-form";


export default function IF_Step2(
   {
      data,
      handlers,
      setCurrentStep,
      handlePolicyHolderAccidentPropChange,
      addPolicyHolderAccident,
      removePolicyHolderAccident,
      handlePolicyHolderConvictionPropChange,
      addPolicyHolderConviction,
      removePolicyHolderConviction
   }
) {
   
   const onPrevBtnClick = (event) => {
      
      setCurrentStep(1);
      
   }
   
   function onNextBtnClick() {
      
      let validationResult = ValidateStep2Data(data);
      
      validationResult.push();
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         });
         
         
      } else {
         setCurrentStep(3);
      }
      
      
   }
   
   
   return (
      <div className='if-step-2'>
         
         <SectionHeading
            text="Your riding"
         />
         
         
         <div className="row">
            
            {/* Policy start date */}
            
            <ScrollableCustomDateTimePickerBlock
               containerCssClass="col-12 py-3 col-md-6"
               labelText="Policy start date"
               required={true}
               controlName="policyStartDate"
               value={data.policyStartDate}
               onChange={handlers.onControlChange}
            />
            
            {/* Policy start date */}
            
            <ScrollableCustomDateTimePickerBlock
               containerCssClass="col-12 py-3 col-md-6"
               labelText="What is the expiry date of your current policy?"
               required={false}
               controlName="currentPolicyExpireDate"
               value={data.currentPolicyExpireDate}
               onChange={handlers.onControlChange}
            />
         
         
         </div>
         
         <div className="row">
            
            {/* Current/Previous insurer */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-6"
               labelText="Current/previous insurer"
               required={false}
               controlName="previousInsurerName"
               value={data.previousInsurerName}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Who will be riding the bike? */}
            
            <ScrollableDropdownBlock
               controlName="bikeRider"
               containerCssClass="col-12 py-3 col-md-6"
               labelText="Who will be riding the bike?"
               required={true}
               options={BIKE_RIDER_OPTIONS}
               selectedValues={data.bikeRider}
               onChange={handlers.onControlChange}
               helpText=""
            />
         </div>
         
         <div className="row">
            {/* What will this bike be used for? */}
            
            <ScrollableDropdownBlock
               controlName="bikeUsage"
               containerCssClass="col-12 py-3 "
               labelText="What will this bike be used for?"
               required={true}
               options={BIKE_USAGE_OPTIONS}
               selectedValues={data.bikeUsage}
               onChange={handlers.onControlChange}
               helpText=""
            />
         </div>
         
         <div className="row">
            {/* What type of Motorcycle licence do you have? */}
            
            <ScrollableDropdownBlock
               controlName="bikeLicenseType"
               containerCssClass="col-12 py-3 "
               labelText="What type of motorcycle licence do you have?"
               required={true}
               options={BIKE_LICENSE_TYPE_OPTIONS}
               selectedValues={data.bikeLicenseType}
               onChange={handlers.onControlChange}
               helpText=""
            />
         </div>
         
         {data.bikeLicenseType !== '' && (
            <div className="row hidden-box">
               
               {/* When did you get this license? */}
               
               <ScrollableCustomDateTimePickerBlock
                  containerCssClass="col-12 py-3 extra"
                  labelText="When did you get this license?"
                  required={data.bikeLicenseType !== ''}
                  controlName="bikeLicenseDate"
                  value={data.bikeLicenseDate}
                  onChange={handlers.onControlChange}
               />
            </div>
         )}
         
         <div className="row">
            {/* Do you have a riding qualification? */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 col-md-6"
               labelText="Do you have a riding qualification?"
               required={true}
               controlName="hasARidingQualification"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.hasARidingQualification}
               onChange={handlers.onControlChange}
            />
            
            {/* Ar you a member of a bike organisation? */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 col-md-6"
               labelText="Are you a member of a bike organisation?"
               required={true}
               controlName="isMemberOfBikeOrganisation"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.isMemberOfBikeOrganisation}
               onChange={handlers.onControlChange}
            />
         </div>
         
         <div className="row">
            {/* How many years' motorcycle No Claims Bonus do you have? */}
            
            <ScrollableDropdownBlock
               controlName="bikeNoClaimBonusYears"
               containerCssClass="col-12 py-3 "
               labelText="How many years' motorcycle No Claims Bonus do you have?"
               required={true}
               options={BIKE_NO_CLAIM_BONUS_YEAR_OPTIONS}
               selectedValues={data.bikeNoClaimBonusYears}
               onChange={handlers.onControlChange}
               helpText=""
            />
         </div>
         
         <div className="row">
            {/* How many other vehicles do you own? */}
            
            <ScrollableDropdownBlock
               controlName="noOfOtherOwnedVehicles"
               containerCssClass="col-12 py-3 "
               labelText="How many other vehicles do you own?"
               required={true}
               options={OTHER_OWNED_VEHICLE_NUMBER_OPTIONS}
               selectedValues={data.noOfOtherOwnedVehicles}
               onChange={handlers.onControlChange}
               helpText=""
            />
         </div>
         
         <div className="row">
            {/* How many other vehicles in your household are you insured to drive? */}
            
            <ScrollableDropdownBlock
               controlName="noOfOtherOwnedAndInsuredVehicles"
               containerCssClass="col-12 py-3 "
               labelText="How many other vehicles in your household are you insured to drive?"
               required={true}
               options={OTHER_OWNED_VEHICLE_NUMBER_OPTIONS}
               selectedValues={data.noOfOtherOwnedAndInsuredVehicles}
               onChange={handlers.onControlChange}
               helpText=""
            />
         </div>
         
         <div className="row">
            {/* Do you have any medical conditions that affect your riding? */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 extra"
               labelText="Do you have any medical conditions that affect your riding?"
               required={true}
               controlName="hasMedicalConditionsAffectingRiding"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.hasMedicalConditionsAffectingRiding}
               onChange={handlers.onControlChange}
            />
         </div>
         
         <SectionHeading
            text="Claims & convictions"
         />
         
         <CommonPolicyHolderClaimsForm
            sectionHeading={`Motor accidents or claims`}
            showSectionHeading={false}
            data={data}
            onChange={handlers.onControlChange}
            
            addPolicyHolderAccident={addPolicyHolderAccident}
            handlePolicyHolderAccidentPropChange={handlePolicyHolderAccidentPropChange}
            removePolicyHolderAccident={removePolicyHolderAccident}
         />
         
         <CommonPolicyHolderConvictionsForm
            sectionHeading={`Motor convictions`}
            showSectionHeading={false}
            data={data}
            onChange={handlers.onControlChange}
            
            addPolicyHolderConviction={addPolicyHolderConviction}
            handlePolicyHolderConvictionPropChange={handlePolicyHolderConvictionPropChange}
            removePolicyHolderConviction={removePolicyHolderConviction}
         />
         
         
         <WizardStepButtonsBlock
            onNextBtnClick={onNextBtnClick}
            onPrevBtnClick={onPrevBtnClick}
            nextButtonAdditionalCssClass={``}
         />
      
      
      </div>
   )
}